export default __webpack_public_path__ + "static/simple-histogram-e9815d201116e23e4be6cdbe85e1c16a.png";